<div class="page-loading d-flex align-items-center justify-content-center">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31.73"
      height="31.729"
      viewBox="0 0 31.73 31.729"
    >
      <path
        id="Path_3422"
        data-name="Path 3422"
        d="M63.762,45.735c-.1-.616-.22-1.225-.375-1.827a15.913,15.913,0,0,0-.765-2.252A16.225,16.225,0,0,0,60.078,37.5a15.69,15.69,0,0,0-8.84-5.227,14,14,0,0,0-2.663-.29,20.667,20.667,0,0,0-2.1.085,16.061,16.061,0,0,0-5.235,1.452,16.332,16.332,0,0,0-3.882,2.564,16.016,16.016,0,0,0-2.989,3.563,15.78,15.78,0,0,0-1.636,12.842,16.3,16.3,0,0,0,.942,2.38,15.9,15.9,0,0,0,4.831,5.752,15.924,15.924,0,0,0,15.073,2.054,15.368,15.368,0,0,0,4.356-2.571,14.508,14.508,0,0,0,1.778-1.835,13.145,13.145,0,0,0,1.459-2.125,15.57,15.57,0,0,0,.907-2.019c.127-.34.248-.68.347-1.034.106-.375.184-.765.255-1.147a6.928,6.928,0,0,0,.092-1.835c-.05.269-.092.531-.156.793a7.722,7.722,0,0,1-.29.892c-.227.616-.51,1.211-.779,1.806a19.087,19.087,0,0,1-1.19,2.182c-.227.361-.46.715-.715,1.055s-.545.666-.836.985A12.3,12.3,0,0,1,56.9,59.554a14.233,14.233,0,0,1-2.274,1.367,14.733,14.733,0,0,1-10.526.864,14.42,14.42,0,0,1-8.025-5.992A13.765,13.765,0,0,1,34.1,51.04c-.092-.439-.163-.892-.212-1.339-.042-.382-.078-.772-.092-1.162a13.871,13.871,0,0,1,.149-2.422,14.239,14.239,0,0,1,8.712-11.078,13.69,13.69,0,0,1,2.649-.772,13.206,13.206,0,0,1,1.381-.191c.227-.021.446-.021.673-.042.092,0,.184.007.276.007a14.319,14.319,0,0,1,4.547.63,13.3,13.3,0,0,1,4.356,2.337,13.643,13.643,0,0,1,3.329,3.952,14.8,14.8,0,0,1,1.551,4.122c.071.333.127.666.184,1a1.089,1.089,0,0,0,2.075.283A1.091,1.091,0,0,0,63.762,45.735Z"
        transform="translate(-32.046 -31.985)" [attr.fill]="color"
        fill="rgb(255, 55, 94)"
      />
      <animateTransform
        attributeName="transform"
        attributeType="XML"
        type="rotate"
        dur="1s"
        from="0"
        to="360"
        repeatCount="indefinite"
      />
    </svg>
  </div>
  